import * as builders from './builders';

export const translateContentToProps = content => {
  const questionType = content.question?.[0].component ?? content.component;
  // eslint-disable-next-line import/namespace
  const builder = builders[questionType];
  return builder.validateSync(content);
};
